import { useEffect } from 'react';
import { useParams } from 'react-router';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useSeoContext } from '@sorare/core/src/contexts/seo';

import { Articles } from '#src/components/Articles/index.tsx';
import { Header } from '#src/components/Header/index.tsx';
import { useCategory } from '#src/hooks/zendesk.ts';
import { categoryPath } from '#src/lib/path.ts';

const Category = () => {
  const { categoryId } = useParams();
  const category = useCategory(parseInt(categoryId || '0', 10));
  const { setPageMetadata } = useSeoContext();

  useEffect(() => {
    if (category) {
      setPageMetadata(category.name, { description: category.description });
    }
  }, [category, setPageMetadata]);

  if (!category) {
    return <LoadingIndicator fullHeight />;
  }

  const sections = [
    {
      name: category.name,
      to: categoryPath(category),
    },
  ];

  return (
    <Vertical gap={3}>
      <Header sections={sections} />
      {category.sections.map(section => (
        <Articles key={section.id} section={section} />
      ))}
    </Vertical>
  );
};

export default Category;
